import React from 'react'
import { connect } from 'react-redux'
import { Card, ListGroup, Button, Row, Col, Modal } from 'react-bootstrap'
import MessageForm from './message_form'
import MessageList from './message_list'
import ShowUsersModal from './show_users_modal'
import { Trans } from 'react-i18next'
import parse from 'html-react-parser'
import {
  getMessages,
  createMessage,
  updateMessage,
  setCurrentMessage,
  resetCurrentMessage,
  markMessages,
  deleteMessage,
  resetScrollToMessage,
} from 'src/store/messages'
import { WithCapabilitiesWrapper, checkCapabilities } from 'src/enhancers/with_capabilities'
import { showConfirmDialog } from 'src/components/system_wide/confirm_dialog'
import { getAllUsers } from 'src/store/users'
import { getAllRoles } from 'src/store/roles_manager'
import { getAllBrands } from 'src/store/brand'

const mstp = state => {
  let { all_brands: brands } = state.brands
  let { all_users: users } = state.users
  let { all_roles: roles } = state.rolesManager
  let { total, messages, show_form, current_message, scroll_to_message_id } = state.messages
  let manage_messages = checkCapabilities(['manage_messages'])
  return { total, messages, show_form, current_message, manage_messages, brands, users, roles, scroll_to_message_id }
}
class Messages extends React.Component {
  state = {
    showModal: false,
  }

  messageFormRef = React.createRef()
  messageListRef = React.createRef()
  showUsersModalRef = React.createRef()

  async componentDidMount() {
    if (this.props.manage_messages) {
      await this.props.dispatch(getAllBrands())
      await this.props.dispatch(getAllUsers({ filtered_roles_priority: [2, 3, 4] }))
      await this.props.dispatch(getAllRoles())
    }
  }
  componentWillUnmount() {
    this.props.dispatch(resetScrollToMessage())
  }

  handleMarkMessage = index => {
    let message = this.props.messages[index]
    this.props.dispatch(markMessages({ message_id: message.id, mark: !message.read_at }))
    this.messageListRef.current.refreshData()
  }

  handleDelete = index => {
    let self = this
    showConfirmDialog(
      <Trans i18nKey="components.messages.delete_message.title">Elimina messaggio</Trans>,
      <Trans i18nKey="components.messages.delete_message.msg">
        Per procedere alla cancellazione del messaggio, click su Elimina
      </Trans>,
      async () => {
        this.props.dispatch(deleteMessage(this.props.messages[index].id))
        self.messageListRef.current.refreshData()
      },
      () => {},
      'primary',
      'Elimina'
    )
  }

  handleShowDetails = msg => {
    this.props.dispatch(setCurrentMessage(msg))
    this.setState({ showModal: true })
  }

  handleShowUsersDetails = msg => {
    this.showUsersModalRef.current.show(msg.users)
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
    this.props.dispatch(resetCurrentMessage())
  }

  showMessageForm = () => {
    this.messageFormRef.current.show({})
  }

  handleSaveMessage = message => {
    message.id === null
      ? this.props.dispatch(createMessage({ message }))
      : this.props.dispatch(updateMessage({ message }))
    this.messageListRef.current.refreshData()
  }

  handleManageRecipients = users => {}

  handleShowRecipients = index => () => {
    let { id, message, title, type, users } = this.props.messages[index]
    let selected_users = (users ?? []).map(u => u.id)
    this.messageFormRef.current.show({ data: { id, message, title, type, selected_users } })
  }

  handleScrollEnd = () => {
    this.props.dispatch(resetScrollToMessage())
  }

  getData = async (index = 0, chunkSize, sortData, filter) => {
    await this.props.dispatch(getMessages({ offset: index, limit: chunkSize, sortData, filter }))
  }

  render() {
    const { showModal } = this.state
    let { messages, total, current_message, manage_messages, scroll_to_message_id } = this.props
    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 pt-2 mb-0">
        <div className="d-flex flex-column flex-fill">
          <Card className="shadow-lg border-0 rounded-3 d-fle flex-fill mb-1">
            <ListGroup variant="flush" className="flex-fill">
              <Row className="mt-2">
                <Col className="d-flex justify-content-start ms-3">
                  <WithCapabilitiesWrapper has={['manage_messages']}>
                    <Button variant="outline-primary" onClick={this.showMessageForm} disabled={showModal}>
                      <i className="fas fa-pen me-0" />
                      <span className="d-none d-sm-inline">
                        <Trans i18nKey="components.messages.add_message">Crea messaggio</Trans>
                      </span>
                    </Button>
                  </WithCapabilitiesWrapper>
                </Col>
              </Row>
              <MessageList
                ref={this.messageListRef}
                manageMessage={manage_messages}
                chunkSize={20}
                getData={this.getData}
                data={messages}
                totalRecords={total}
                scrollToMessageId={scroll_to_message_id}
                onDelete={this.handleDelete}
                onMarkMessage={this.handleMarkMessage}
                onShowDetails={this.handleShowDetails}
                onChangeRecipients={this.handleShowRecipients}
                onShowUsersDetails={this.handleShowUsersDetails}
                onScollEnd={this.handleScrollEnd}
              />
            </ListGroup>
          </Card>

          {current_message && (
            <Modal
              show={showModal}
              backdrop="static"
              size="xl"
              keyboard={false}
              centered
              onHide={this.handleCloseModal}
              scrollable>
              <Modal.Header style={{ backgroundColor: '$primary-color', color: 'white' }}>
                <Modal.Title>{current_message.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ minHeight: '60vh', overflow: 'auto' }}>
                <div className="ql-editor">{parse(current_message.message)}</div>
              </Modal.Body>
              <div className="border-top pt-2">
                <Button className="float-end me-2" variant="secondary" onClick={this.handleCloseModal}>
                  <Trans i18nKey="buttons.close">Chiudi</Trans>
                </Button>
              </div>
            </Modal>
          )}
        </div>
        <MessageForm
          ref={this.messageFormRef}
          users={this.props.users}
          roles={this.props.roles}
          brands={this.props.brands}
          onSave={this.handleSaveMessage}
          onChangeRecipients={this.handleManageRecipients}
        />
        <ShowUsersModal ref={this.showUsersModalRef} />
      </div>
    )
  }
}

export default connect(mstp)(Messages)
